import { TFunction } from '@lyearn/i18n';
import { ContentEntity, EventUnion, MentionEntityTypeEnum, UserType } from '@/types/schema';

import { ItemTypeEnum, RenderItemType } from './types';

export const getRenderItems = ({
  users,
  events,
  contents,
  t,
}: {
  users: UserType[];
  events: EventUnion[];
  contents: ContentEntity[];
  t: TFunction;
}) => {
  const renderItems: RenderItemType[] = [];
  const userItems = users.slice(0, 2);
  const contentItems = contents.slice(0, 2);
  const eventItems = events.slice(0, 2);

  if (userItems.length) {
    renderItems.push({
      type: ItemTypeEnum.Header,
      item: {
        heading: t('Channel:Learners'),
        id: MentionEntityTypeEnum.User,
      },
    });

    userItems.forEach((item, index) => {
      renderItems.push({ type: MentionEntityTypeEnum.User, item, index });
    });
  }

  if (contentItems.length) {
    renderItems.push({
      type: ItemTypeEnum.Header,
      item: {
        heading: t('Channel:Content'),
        id: MentionEntityTypeEnum.Content,
      },
    });

    contentItems.forEach((item, index) => {
      renderItems.push({
        type: MentionEntityTypeEnum.Content,
        item,
        index: userItems.length + index,
      });
    });
  }

  if (eventItems.length) {
    renderItems.push({
      type: ItemTypeEnum.Header,
      item: {
        heading: t('Common:Sessions'),
        id: MentionEntityTypeEnum.Event,
      },
    });

    eventItems.forEach((item, index) => {
      renderItems.push({
        type: MentionEntityTypeEnum.Event,
        item,
        index: userItems.length + contentItems.length + index,
      });
    });
  }

  return renderItems;
};
